import React from "react";
import "./ChooseMinemi.css";

const ChooseMinemi = () => {
  return (
    <>
      <div id="choose-minemi-loan-eligibility" className="bg-transparent">
        <div id="list-of-documents-container">
          <div id="documents-content" className="bg-transparent">
            <div className="documents-content-container bg-transparent">
              <div className="content-box w-100 bg-transparent ">
                {" "}
                <div className="documents-text-box bg-transparent">
                  <div className="bg-transparent">
                    <div id="choose-minemi-head-box" className="bg-transparent">
                      <div className="choose-minemi-heading bg-transparent">
                        <h4 id="documents-heading" className="bg-transparent">
                          Why Choose MinEmi for Lower Your EMIs?
                        </h4>
                      </div>
                    </div>

                    <div className="text-box bg-transparent">
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent">
                          Lower Your EMI by Switching to Better Rates.
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent">
                          Quick & Hassle-Free Balance Transfer Process.
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent">
                          Transparent Terms, No Hidden Costs.
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent">
                          Expert Guidance to Maximize Your Savings.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="documents-image-box d-none d-md-block">
                  <div>
                    <img
                      className="documents-image"
                      src={Image}
                      alt="docuents-image"
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChooseMinemi;
